module.exports = __webpack_public_path__ + "img/montserrat.d0bb886c.svg";